import React, { ReactNode } from 'react';

interface HorizontalScrollProps {
  children: ReactNode;
}

const HorizontalScroll = ({ children }: HorizontalScrollProps) => {
  return <>{children}</>;
};

export default HorizontalScroll;
